
import { useState } from 'react';

const FaqAccordion = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Cuánto cuesta un vaciado de piso en Castelldefels?',
      answer: 'El precio de un vaciado de piso en Castelldefels depende de varios factores: tamaño del inmueble, cantidad de enseres a retirar, estado de limpieza, accesibilidad y servicios adicionales requeridos. Realizamos una visita gratuita para evaluar el trabajo y ofrecerte un presupuesto detallado sin compromiso. De media, un vaciado completo de piso puede oscilar entre 400€ y 1.500€, pero cada caso es único. Factores como la presencia de ascensor, necesidad de limpieza extrema o servicios adicionales como pintura pueden influir en el precio final.',
    },
    {
      question: '¿Cuánto tiempo tarda el servicio de vaciado?',
      answer: 'El tiempo necesario depende del tamaño del inmueble y la cantidad de enseres. Un piso estándar de 2-3 habitaciones suele tardar entre 4 y 8 horas. Pisos más grandes o casos de acumulación extrema pueden requerir 1-3 días. En casos urgentes, podemos movilizar más personal para acelerar el proceso. Te informamos del tiempo estimado en el presupuesto. Nuestro equipo trabaja de forma eficiente para minimizar las molestias y completar el trabajo en el menor tiempo posible sin comprometer la calidad.',
    },
    {
      question: '¿Qué hacen con los residuos y muebles retirados?',
      answer: 'Gestionamos todos los residuos de forma legal y responsable. Los muebles y enseres en buen estado los donamos a entidades sociales y ONG de Castelldefels y comarca que trabajan con familias necesitadas. Los materiales reciclables (papel, cartón, plástico, metal) los llevamos a puntos limpios autorizados. Los residuos no aprovechables se transportan a vertederos legales homologados. Te entregamos certificado de gestión de residuos si lo necesitas para trámites administrativos. Nuestro compromiso con el medio ambiente y la responsabilidad social es prioritario.',
    },
    {
      question: '¿Ofrecen servicio discreto para casos delicados?',
      answer: 'Sí, la discreción es una de nuestras prioridades, especialmente en casos de síndrome de Diógenes, desahucios o situaciones familiares delicadas. Nuestro equipo trabaja con uniformes neutros, vehículos sin rotulación llamativa y máxima confidencialidad. Respetamos los horarios que prefieras y adaptamos nuestro trabajo a tus necesidades de privacidad. Entendemos que muchas situaciones son emocionalmente difíciles y tratamos cada caso con empatía, respeto y profesionalidad. Nunca comentamos detalles del trabajo con vecinos o terceros.',
    },
    {
      question: '¿Trabajan con comunidades de vecinos y administradores de fincas?',
      answer: 'Sí, colaboramos habitualmente con administradores de fincas, comunidades de vecinos e inmobiliarias en Castelldefels, Gavà, Viladecans y toda la comarca. Ofrecemos condiciones especiales y tarifas preferenciales para profesionales con necesidades recurrentes. Nos encargamos de vaciados de pisos abandonados, trasteros comunitarios y limpieza de zonas comunes. Emitimos facturas y certificados necesarios para la gestión administrativa. Tenemos experiencia trabajando con los protocolos y requisitos específicos de comunidades de propietarios.',
    },
    {
      question: '¿Tienen servicio de urgencia 24 horas?',
      answer: 'Sí, ofrecemos servicio de urgencia disponible 24 horas al día, 7 días a la semana, incluidos festivos y fines de semana. Si necesitas un vaciado o limpieza urgente en Castelldefels, llámanos al 602 36 59 96 y movilizaremos un equipo lo antes posible. Entendemos que algunas situaciones requieren respuesta inmediata (inundaciones, desahucios urgentes, preparación rápida de inmuebles) y estamos preparados para atenderlas. Nuestro equipo de guardia puede estar en tu ubicación en pocas horas.',
    },
    {
      question: '¿El presupuesto es realmente sin compromiso?',
      answer: 'Sí, totalmente. Realizamos una visita gratuita a tu inmueble en Castelldefels o alrededores, evaluamos el trabajo necesario y te entregamos un presupuesto detallado sin ningún compromiso por tu parte. No tienes que contratar el servicio si el presupuesto no se ajusta a tus necesidades o expectativas. Solo cobramos si decides contratarnos y el precio final será exactamente el presupuestado, sin sorpresas ni costes ocultos. La transparencia es fundamental en nuestra forma de trabajar.',
    },
    {
      question: '¿Cubren toda el área del Baix Llobregat?',
      answer: 'Sí, ofrecemos nuestros servicios en Castelldefels (Centre, La Pineda, Montemar, Can Roca, Bellamar, Vista Alegre, Granvia Mar, Baixador) y toda la comarca del Baix Llobregat Sud, incluyendo Gavà, Viladecans, El Prat de Llobregat, Sant Boi de Llobregat, Sitges y la zona sur de Barcelona. También atendemos localidades cercanas como Cornellà, Esplugues o Sant Joan Despí. Si tu ubicación no está en la lista, contáctanos y te informaremos sobre la disponibilidad de nuestros servicios en tu zona.',
    },
  ];

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-silver-light rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-card"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer hover:bg-silver-light/20 transition-colors"
              >
                <h3 className="text-lg font-bold text-graphite pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-primary flex-shrink-0 transition-transform duration-300`}
                ></i>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-6">
                  <p className="text-gray-dark leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqAccordion;
